import { api, unwrap } from './client';
import { paymentFromApi, paymentToApi } from './_transforms';

const PAGE_SIZE = 500;

export async function listPayments({ page = 0, size = PAGE_SIZE, sort = 'paymentDate,desc', q, type, status } = {}) {
  const params = { page, size, sort };
  if (q) params.q = q;
  if (type) params.type = type.toUpperCase();
  if (status) params.status = status.toUpperCase();
  const data = await unwrap(api.get('/api/payments', { params }));
  return {
    content: (data.content || []).map(paymentFromApi),
    totalElements: data.totalElements,
    totalPages: data.totalPages,
    number: data.number,
  };
}

export async function listRecentPayments() {
  const data = await unwrap(api.get('/api/payments/recent'));
  return (data || []).map(paymentFromApi);
}

export async function getPayment(id) {
  const data = await unwrap(api.get(`/api/payments/${id}`));
  return paymentFromApi(data);
}

export async function createPayment(payload) {
  const data = await unwrap(api.post('/api/payments', paymentToApi(payload)));
  return paymentFromApi(data);
}

export async function updatePayment(id, payload) {
  const data = await unwrap(api.put(`/api/payments/${id}`, paymentToApi(payload)));
  return paymentFromApi(data);
}

export async function markPaymentPaid(id) {
  const data = await unwrap(api.post(`/api/payments/${id}/mark-paid`));
  return paymentFromApi(data);
}

export async function deletePayment(id) {
  return unwrap(api.delete(`/api/payments/${id}`));
}
